<!-- <div class="container" *ngIf="showCategories">
  <div class="row">
    <div class="col admin-instructions title-bar">
      <h3>Textilefabric Categories</h3>
      <p>Below is a list of categories.  Click on the Edit button to edit the selected category and subcategories.</p>
    </div>
  </div>
  <div class="row">
      <div class="col">
        <p-table [value]="categories" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
              <tr>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Total Subcategories</th>
                  <th>Action</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-c>
              <tr>
                  <td>{{ c.name }}</td>
                  <td><img src="{{ imageSource }}/{{ c.imagePath }}" alt="Category Image" width="100" class="shadow-4" /></td>
                  <td>{{ c.children.length }}</td>
                  <td>
                      <button class="btn btn-success" [routerLink]="['/admin/categories', c.id]"><i class="fa fa-check"></i>&nbsp;Edit</button>
                  </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="4">
                <form [formGroup]="categoryForm" (ngSubmit)="submit()">
                  <div class="input-group">
                    <input type="text" class="form-control" formControlName="name" placeholder="Enter parent category name" />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">Add</button>
                    </div>
                  </div>
                </form>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                In total there are {{categories ? categories.length : 0 }} categories.
            </div>
        </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div> -->
<!-- Category List Page -->

<div class="container py-4">
  <!-- Page Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h2 class="fw-bold text-light mb-1">Product Categories</h2>
          <p class="text-light mb-0">Manage your product categories and subcategories</p>
        </div>
        <button 
          class="btn btn-primary btn-lg px-4"
          (click)="onAddCategory()"
          type="button">
          <i class="fa fa-plus me-2"></i>Add Category
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="row">
    <div class="col-12">
      <div class="d-flex justify-content-center align-items-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span class="ms-3 text-muted">Loading categories...</span>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="row">
    <div class="col-12">
      <div class="alert alert-danger d-flex align-items-center" role="alert">
        <i class="fa fa-exclamation-triangle me-3"></i>
        <div>
          <strong>Error!</strong> {{ error }}
          <button class="btn btn-outline-danger btn-sm ms-3" (click)="loadCategories()">
            Try Again
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Categories Grid -->
  <div *ngIf="!loading && !error" class="row">
    <!-- Category Cards -->
    <div class="col-xl-4 col-lg-6 col-md-6 mb-4" *ngFor="let category of categories">
      <div class="card h-100 shadow-sm border-0">
        <!-- Category Image -->
        <div class="position-relative">
          <img 
            [src]="category.imagePath ? (imageSource + '/' + category.imagePath) : ''" 
            [alt]="category.name"
            class="card-img-top"
            style="height: 200px; object-fit: cover;"
            onerror="this.src=''">
          
          <!-- Status Badge -->
          <span class="position-absolute top-0 end-0 m-3">
            <span 
              class="badge"
              [class]="category.activeFlag ? 'bg-success' : 'bg-secondary'">
              {{ category.activeFlag ? 'Active' : 'Inactive' }}
            </span>
          </span>
        </div>

        <!-- Card Body -->
        <div class="card-body d-flex flex-column">
          <!-- Category Name -->
          <h5 class="card-title fw-bold text-dark mb-2">{{ category.name }}</h5>
          
          <!-- Subcategory Count -->
          <div class="mb-3 flex-grow-1">
            <div class="d-flex align-items-center text-muted">
              <i class="fa fa-folder-open me-2"></i>
              <span class="fw-medium">{{ category.children.length }}</span>
              <span class="ms-1">{{ category.children.length === 1 ? 'subcategory' : 'subcategories' }}</span>
            </div>
            
            <!-- Created Date -->
            <!-- <div class="d-flex align-items-center text-muted mt-2">
              <i class="fas fa-calendar-alt me-2"></i>
              <small>Created: {{ category.createdDate }}</small>
            </div> -->
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-auto">
            <button 
              class="btn btn-outline-primary btn-sm flex-fill"
              (click)="onEditCategory(category)"
              type="button">
              <i class="fa fa-edit me-1"></i>Edit
            </button>
            
            <button 
              class="btn btn-sm flex-fill"
              [class]="category.activeFlag ? 'btn-outline-warning' : 'btn-outline-success'"
              (click)="onToggleStatus(category)"
              type="button">
              <i class="fa" [class]="category.activeFlag ? 'fa-pause' : 'fa-play'" [class.me-1]="true"></i>
              {{ category.activeFlag ? 'Deactivate' : 'Activate' }}
            </button>
            
            <button 
              class="btn btn-outline-danger btn-sm"
              (click)="onDeleteCategory(category)"
              type="button"
              title="Delete Category">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="categories.length === 0" class="col-12">
      <div class="text-center py-5">
        <div class="mb-4">
          <i class="fa fa-folder-open text-muted" style="font-size: 4rem;"></i>
        </div>
        <h4 class="text-muted mb-3">No Categories Found</h4>
        <p class="text-muted mb-4">Get started by adding your first product category.</p>
        <button 
          class="btn btn-primary btn-lg px-4"
          (click)="onAddCategory()"
          type="button">
          <i class="fa fa-plus me-2"></i>Add Your First Category
        </button>
      </div>
    </div>
  </div>

  <!-- Summary Stats -->
  <!-- <div *ngIf="categories.length > 0 && !loading && !error" class="row mt-4">
    <div class="col-12">
      <div class="card bg-light border-0">
        <div class="card-body">
          <div class="row text-center">
            <div class="col-md-3 col-6 mb-3 mb-md-0">
              <div class="fw-bold text-primary fs-4">{{ categories.length }}</div>
              <div class="text-muted small">Total Categories</div>
            </div>
            <div class="col-md-3 col-6 mb-3 mb-md-0">
              <div class="fw-bold text-success fs-4">{{ (categories | filterBy:['isActive']:[true]).length }}</div>
              <div class="text-muted small">Active Categories</div>
            </div>
            <div class="col-md-3 col-6">
              <div class="fw-bold text-info fs-4">{{ categories.length }}</div>
              <div class="text-muted small">Total Subcategories</div>
            </div>
            <div class="col-md-3 col-6">
              <div class="fw-bold text-warning fs-4">{{ (categories | filterBy: ['isActive']:[false]).length }}</div>
              <div class="text-muted small">Inactive Categories</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

</div>
